module.exports = __webpack_public_path__ + "img/00026.d8d83bf2.webp";